import React from "react";

export const LiveStatusBadge: React.FC = () => (
  <div className="inline-flex items-center gap-2.5 px-3 py-1.5 border border-accent/20 text-[10px] font-mono uppercase tracking-[0.16em] text-accent">
    <span className="relative w-1.5 h-1.5 flex-shrink-0">
      <span className="absolute inset-0 rounded-full bg-accent animate-ping" />
      <span className="relative block w-1.5 h-1.5 rounded-full bg-accent" />
    </span>
    Software Engineer — AI Native
  </div>
);
